"use client";

import { motion } from "framer-motion";
import bento1 from "@/assets/bento-1.jpg";
import bento2 from "@/assets/bento-2.jpg";
import bento3 from "@/assets/bento-3.jpg";
import bento4 from "@/assets/bento-4.jpg";
import bento5 from "@/assets/bento-5.jpg";

export function Gallery() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: [0.21, 0.47, 0.32, 0.98],
      },
    },
  };

  return (
    <section id="gallery" className="py-28 lg:py-32 bg-surface overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex items-end justify-between gap-8 mb-14">
          <motion.div 
            className="max-w-xl"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs uppercase tracking-[0.25em] text-primary mb-5">In the wild</p>
            <h2 className="text-4xl lg:text-5xl font-semibold tracking-tight">
              At home, everywhere.
            </h2>
          </motion.div>
        </div>
        
        <motion.div 
          className="grid grid-cols-12 gap-4 lg:gap-5 h-auto lg:h-[720px]"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.div variants={itemVariants} className="col-span-12 sm:col-span-6 lg:col-span-5 lg:row-span-2 aspect-[4/5] lg:aspect-auto overflow-hidden rounded-3xl">
            <img src={bento4.src} alt="Smart bathroom" loading="lazy" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
          </motion.div>
          <motion.div variants={itemVariants} className="col-span-6 lg:col-span-4 aspect-square lg:aspect-auto overflow-hidden rounded-3xl">
            <img src={bento2.src} alt="Family using Apollo" loading="lazy" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
          </motion.div>
          <motion.div variants={itemVariants} className="col-span-6 lg:col-span-3 aspect-square lg:aspect-auto overflow-hidden rounded-3xl">
            <img src={bento3.src} alt="Apollo light ring detail" loading="lazy" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
          </motion.div>
          <motion.div variants={itemVariants} className="col-span-6 lg:col-span-3 aspect-square lg:aspect-auto overflow-hidden rounded-3xl">
            <img src={bento1.src} alt="Modern entryway" loading="lazy" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
          </motion.div>
          <motion.div variants={itemVariants} className="col-span-6 lg:col-span-4 aspect-square lg:aspect-auto overflow-hidden rounded-3xl">
            <img src={bento5.src} alt="Outdoor patio" loading="lazy" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
